import gql from 'graphql-tag'
import { cashRegisterFragment } from './fragments'

export const listRestaurantProject = gql`
	query {
		cashAssist {
			listRestaurantProject {
				objectType
				caption
				id
				mod_ver
				floors{
					objectType
					number
					projectId
					id
					mod_ver
					rooms{
						objectType
						caption
						projectId
						floorId
						id
						mod_ver
						roomColor
						furniture {
							projectId
							floorId
							roomId
							id
							mod_ver
							objectType
							objectKind
							caption
							componentColor
							positionTop
							positionLeft
							rotationDeg
							height
							width
							shape
						}
					}
				}
			}
		}
	}
`

export const listRestaurantOpenedTables = gql`
	query listRestaurantOpenedTables($shopId: ID!, $projectId: ID!) {
		cashAssist {
			listRestaurantOpenedTables(shopId: $shopId, projectId: $projectId) {
				lastModified
				userName
				clientName
				tableNumber
				hardwareId
			}
	}
}
`
export const getBranchList = gql`
	query {
		cashAssist {
			clientTree {
			regions {
				id,
				name
				shops {
				id
				name
				cashRegisters {
					...CashRegisterFragment
				}
				}
			}
			}
		}
	}
${cashRegisterFragment}
`

